<template>
  <div class="d-flex flex-column justify-content-end w-100">
    <label
      v-if="itemModel.vars.label"
      :class="
        'form-label' +
        (itemModel.vars.label_attr && itemModel.vars.label_attr.class ? ' ' + itemModel.vars.label_attr.class : '') +
        (itemModel.vars.required ? ' required' : '')
      "
    >
      {{ index ? index + ". " : "" }}{{ itemModel.vars.label }}{{ itemModel.vars.required ? "*" : "" }}
      <span
        v-if="itemModel.vars.help && !isMobile()"
        class="form-info ms-1"
        v-tooltip="{ title: itemModel.vars.help, textWrap: true }"
      >
        <FontAwesomeIcon icon="fa-light fa-circle-question" />
      </span>
    </label>
    <div v-if="isMobile() && itemModel.vars.help" class="form-info">
      <FontAwesomeIcon icon="fa-light fa-circle-question" />
      {{ itemModel.vars.help }}
    </div>
    <div class="slider-number-wrapper position-relative">
      <input
        v-model.number="itemModel.vars.value"
        type="number"
        :class="['form-control', 'slider-number-input', 'mb-2', numberInputClass]"
        :disabled="itemModel.vars.disabled === true || forcedDisabled"
        :readonly="itemModel.vars.attr && itemModel.vars.attr.readonly"
        min="0"
        max="100"
        @blur="blur"
        @input="input"
        @keydown="filterKey"
      />
      <div class="input__currency">%</div>
    </div>
    <div v-if="itemModel.vars.error" class="invalid-feedback d-block">
      {{ itemModel.vars.error }}
    </div>
    <div>
      <div class="custom-progress progress-up">
        <input
          :id="itemModel.vars.id"
          v-model="itemModel.vars.value"
          v-if="!itemModel.vars.hide"
          :readonly="itemModel.vars.attr && itemModel.vars.attr.readonly"
          :class="itemClass + ' ' + (itemModel.vars.attr && itemModel.vars.attr.class ? itemModel.vars.attr.class : '')"
          :disabled="itemModel.vars.disabled === true || forcedDisabled"
          :name="language ? itemModel.vars.name + '-' + language : itemModel.vars.name"
          :placeholder="itemModel.vars.attr && itemModel.vars.attr.placeholder ? itemModel.vars.attr.placeholder : ''"
          :required="itemModel.vars.required === true"
          type="range"
          min="0"
          max="100"
          :style="{ '--slider-progress': progressPercent }"
          :maxlength="itemModel.vars.attr && itemModel.vars.attr.maxlength ? itemModel.vars.attr.maxlength : ''"
          @blur="blur"
          @change="change"
          @focus="focus"
          @input="input"
        />
        <div class="levels">
          <span class="level -start">{{ $t("slider.start") }}</span>
          <span class="level -center">{{ $t("slider.in_progress") }}</span>
          <span class="level -end">{{ $t("slider.end") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "SliderTypeComponent",
  components: {
    FontAwesomeIcon,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    language: {
      type: String,
      required: false,
      default: "fr",
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
    forcedDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["inputModel", "input", "draft", "focus", "update", "focused", "save", "buttonAction"],
  data() {
    return {
      itemModel: this.model,
      itemClass: "progress-range-counter form-range form-slider",
      numberInputClass: "",
    };
  },
  computed: {
    progressPercent() {
      return this.clampPercent(this.itemModel.vars.value);
    },
  },
  watch: {
    "itemModel.vars.error"(newVal) {
      if (newVal) {
        this.numberInputClass = "is-invalid";
      }
    },
    "itemModel.vars.isInvalid"(newVal) {
      if (newVal) {
        this.numberInputClass = "is-invalid";
      }
    },
    model() {
      this.itemModel.vars.value = this.model?.vars?.value;
    },
  },
  methods: {
    blur() {
      this.valid(true);
      this.$emit("update", this.itemModel.vars.value, this.index);
    },
    input() {
      this.clampValue();
      this.valid();
      this.$emit("update", this.itemModel.vars.value, this.index);
      this.$emit("input", this.itemModel.vars.value, this.index);
      this.$emit("inputModel", this.itemModel);
    },
    change() {
      this.$emit("draft", this.itemModel);
      this.$emit("update", this.itemModel.vars.value, this.index);
    },
    focus() {
      this.$emit("focus");
    },
    filterKey(event) {
      const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
      if (!allowed.includes(event.key) && !/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
    clampPercent(value) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return 0;
      }
      return Math.min(100, Math.max(0, number));
    },
    // La saisie en cours passe ici à chaque frappe : une valeur vide ou non numérique est laissée
    // telle quelle, seule une valeur hors bornes est réécrite.
    clampValue() {
      const raw = this.itemModel.vars.value;
      if (raw === "" || raw === null || raw === undefined) {
        return;
      }
      const value = Number(raw);
      if (Number.isNaN(value)) {
        return;
      }
      const clamped = this.clampPercent(value);
      if (clamped !== value) {
        this.itemModel.vars.value = clamped;
      }
    },
    isMobile() {
      return window.innerWidth < 992;
    },
    getClass() {
      const value = this.itemModel.vars.value;
      const isEmpty = value === null || value === undefined || value === "";
      if (this.itemModel.vars.required && isEmpty) {
        this.itemModel.vars.error = this.$t("requiredField");
        this.numberInputClass = "is-invalid";
      } else if (this.itemModel.vars.required) {
        delete this.itemModel.vars.error;
        this.numberInputClass = "is-valid";
      } else {
        delete this.itemModel.vars.error;
        this.numberInputClass = "";
      }
    },
    valid(blur = false) {
      this.getClass();
      if (blur) {
        this.$emit("save");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  &.form-control.is-valid,
  &.form-control.is-invalid {
    background: $white;

    @include dark-theme {
      background: $dark-theme-bg;
    }
  }
}

.input__currency {
  position: absolute;
  right: 1px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: calc(100% - 2px);
  background: $m_color_3;
  border-left: none;
  border-radius: 0 $radius $radius 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;

  @include dark-theme {
    background: $dark-theme-bg;
    border-left: 1px solid $m-color_12;
  }
}

.slider-number-wrapper {
  max-width: 110px;
  max-height: 40px;
}

.slider-number-input {
  width: 100%;
}

.custom-progress {
  width: 100%;
}

.levels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 12px;
  color: $m_color_6;
}

$slider-thumb-size: 16px;
$slider-thumb-radius: $slider-thumb-size * 0.5;
// Contraste vérifié RGAA 3.2 / WCAG 1.4.11 : #506690 sur $m-color_1 = 4,7:1, #009688 sur
// $m-color_18 = 4,4:1 ; le gris précédent tombait à 1,99:1.
$slider-thumb-color: $m-color_7;
$slider-thumb-color-dark: $m-color_14;

// Le curseur parcourt la piste amputée de sa propre largeur : sans cette correction, la frontière
// gris/dégradé est décalée d'un demi-curseur par rapport au centre du thumb aux extrémités.
@mixin slider-track($remaining-color) {
  background-image: linear-gradient(90deg, $remaining-color, $remaining-color), $progress-gradient;
  background-size:
    calc(100% - (var(--slider-progress, 0) * (100% - #{$slider-thumb-size}) / 100 + #{$slider-thumb-radius})) 100%,
    100% 100%;
  background-position:
    right center,
    left center;
  background-repeat: no-repeat;
}

// Les pseudo-éléments préfixés doivent rester dans des règles séparées : groupés, un moteur qui
// n'en reconnaît pas un ignore la règle entière.
// La géométrie du thumb vivait dans dark.scss et users/account-setting.scss, que ce sélecteur plus
// spécifique rendait inopérants : elle est rapatriée ici, seule source de vérité du composant.
@mixin slider-thumb($color) {
  -webkit-appearance: none;
  appearance: none;
  width: $slider-thumb-size;
  height: $slider-thumb-size;
  margin-top: -4px;
  background: $color;
  border: none;
  border-radius: 50%;
  box-shadow: none;
  transition: all 0.35s ease;
  // La règle globale qui porte le cursor: pointer est confinée au scope `.skill`.
  cursor: pointer;
}

// Bootstrap applique au curseur une ombre portée décalée vers le bas : on la remplace par un halo
// centré et opaque, qui sert aussi d'indicateur de focus visible (RGAA 10.7) que le thème annulait.
@mixin slider-thumb-highlight($ring-base, $ring-color) {
  box-shadow:
    0 0 0 2px $ring-base,
    0 0 0 4px $ring-color;
}

.form-slider.progress-range-counter {
  cursor: pointer;

  &:disabled {
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid $slider-thumb-color;
    outline-offset: 2px;

    @include dark-theme {
      outline-color: $slider-thumb-color-dark;
    }
  }

  &::-webkit-slider-thumb {
    @include slider-thumb($slider-thumb-color);
  }

  &::-moz-range-thumb {
    @include slider-thumb($slider-thumb-color);
  }

  @include dark-theme {
    &::-webkit-slider-thumb {
      background: $slider-thumb-color-dark;
    }

    &::-moz-range-thumb {
      background: $slider-thumb-color-dark;
    }

    &:not(:disabled):hover::-webkit-slider-thumb,
    &:not(:disabled):active::-webkit-slider-thumb,
    &:focus-visible::-webkit-slider-thumb {
      @include slider-thumb-highlight($m-color_18, $slider-thumb-color-dark);
    }

    &:not(:disabled):hover::-moz-range-thumb,
    &:not(:disabled):active::-moz-range-thumb,
    &:focus-visible::-moz-range-thumb {
      @include slider-thumb-highlight($m-color_18, $slider-thumb-color-dark);
    }
  }

  &:not(:disabled):hover::-webkit-slider-thumb,
  &:not(:disabled):active::-webkit-slider-thumb,
  &:focus-visible::-webkit-slider-thumb {
    @include slider-thumb-highlight($white, $slider-thumb-color);
  }

  &:not(:disabled):hover::-moz-range-thumb,
  &:not(:disabled):active::-moz-range-thumb,
  &:focus-visible::-moz-range-thumb {
    @include slider-thumb-highlight($white, $slider-thumb-color);
  }

  &:disabled::-webkit-slider-thumb {
    cursor: default;
  }

  &:disabled::-moz-range-thumb {
    cursor: default;
  }
}

.form-slider {
  &::-webkit-slider-runnable-track {
    @include slider-track($m-color_1);

    @include dark-theme {
      @include slider-track($m-color_18);
    }
  }

  &::-moz-range-track {
    @include slider-track($m-color_1);

    @include dark-theme {
      @include slider-track($m-color_18);
    }
  }
}
</style>
